export default __webpack_public_path__ + "static/media/swipeSelected.5a16d70f.svg";